module.exports = __webpack_public_path__ + "46cf1067-688d-4aab-b0f7-bd942af6efd8.ttf";